(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["klaviyo-collection-bis"] && !Shopify.designMode) return;
  try {
    // Klaviyo Collection Back in Stock Implementation
  (function () {
    'use strict';

    // Configuration
    const KLAVIYO_CONFIG = {
      publicApiKey: 'UGnYgd', // Your public API key
      listId: 'VgUwFr', // Your newsletter list ID
      apiEndpoint: 'https://a.klaviyo.com/client/back-in-stock-subscriptions/',
      revision: '2024-06-15',
    };

    // Modal HTML template (now using CSS classes)
    const MODAL_TEMPLATE = `
      <div id="klaviyo-collection-bis-modal">
        <div class="klaviyo-bis-modal-content">
          <button type="button" id="klaviyo-bis-close">&times;</button>
          
          <h3 id="klaviyo-bis-title" class="ob-h4">Product Name</h3>
          
          <p class="klaviyo-bis-description ob-body">Drop your email. We'll send you an email when we're back in stock!</p>
          
          <form id="klaviyo-bis-form">
            <input 
              type="email" 
              id="klaviyo-bis-email" 
              placeholder="Email" 
              class="ob-body"
              required 
            />
            
            <button 
              type="submit" 
              id="klaviyo-bis-submit"
              class="ob-body"
            >
              Notify me when available
            </button>
          </form>
          
          <div id="klaviyo-bis-success" class="klaviyo-bis-success">
            <div class="klaviyo-bis-success-message ob-body">
              You're all set. We'll let you know when these are back in stock.
            </div>
            <button 
              onclick="closeKlaviyoBisModal()" 
              class="klaviyo-bis-close-button ob-body"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    `;

    // Show modal function
    window.showKlaviyoBisModal = function (productId, productName, variantId) {
      // Remove existing modal
      const existingModal = document.getElementById('klaviyo-collection-bis-modal');
      if (existingModal) {
        existingModal.remove();
      }

      // Insert modal
      document.body.insertAdjacentHTML('beforeend', MODAL_TEMPLATE);

      // Set product name
      document.getElementById('klaviyo-bis-title').textContent = productName || 'Product';

      // Store product info on modal
      const modal = document.getElementById('klaviyo-collection-bis-modal');
      modal.dataset.productId = productId;
      modal.dataset.variantId = variantId || productId;
      modal.dataset.productName = productName || 'Product';

      // Add event listeners
      setupModalEventListeners();
    };

    // Close modal function
    window.closeKlaviyoBisModal = function () {
      const modal = document.getElementById('klaviyo-collection-bis-modal');
      if (modal) {
        modal.remove();
      }
    };

    // Setup modal event listeners
    function setupModalEventListeners() {
      const modal = document.getElementById('klaviyo-collection-bis-modal');
      const closeBtn = document.getElementById('klaviyo-bis-close');
      const form = document.getElementById('klaviyo-bis-form');

      // Close button
      if (closeBtn) {
        closeBtn.addEventListener('click', window.closeKlaviyoBisModal);
      }

      // Click outside to close
      if (modal) {
        modal.addEventListener('click', function (e) {
          if (e.target === modal) {
            window.closeKlaviyoBisModal();
          }
        });
      }

      // Form submission
      if (form) {
        form.addEventListener('submit', handleFormSubmission);
      }
    }

    // Handle form submission
    async function handleFormSubmission(e) {
      e.preventDefault();

      const modal = document.getElementById('klaviyo-collection-bis-modal');
      const email = document.getElementById('klaviyo-bis-email').value;
      const submitBtn = document.getElementById('klaviyo-bis-submit');

      const productId = modal.dataset.productId;
      const variantId = modal.dataset.variantId;
      const productName = modal.dataset.productName;

      if (!email || !email.includes('@')) {
        alert('Please enter a valid email address.');
        return;
      }

      // Disable submit button
      submitBtn.disabled = true;
      submitBtn.textContent = 'Subscribing...';

      try {
        // Create back in stock subscription
        await createBackInStockSubscription(email, variantId, productName);

        // Show success message
        showSuccessMessage();

        // Auto close after 3 seconds
        setTimeout(() => {
          window.closeKlaviyoBisModal();
        }, 3000);
      } catch (error) {
        console.error('Error subscribing:', error);
        alert('There was an error processing your request. Please try again.');

        // Re-enable submit button
        submitBtn.disabled = false;
        submitBtn.textContent = 'Notify me when available';
      }
    }

    // Create back in stock subscription via Klaviyo API
    async function createBackInStockSubscription(email, variantId, productName) {
      const payload = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                },
              },
            },
            channels: ['EMAIL'],
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: `$shopify:::$default:::${variantId}`,
              },
            },
          },
        },
      };

      const response = await fetch(`${KLAVIYO_CONFIG.apiEndpoint}?company_id=${KLAVIYO_CONFIG.publicApiKey}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          revision: KLAVIYO_CONFIG.revision,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error(`Back in stock API error: ${response.status}`);
      }

      return response;
    }

    // Show success message
    function showSuccessMessage() {
      const form = document.getElementById('klaviyo-bis-form');
      const success = document.getElementById('klaviyo-bis-success');

      if (form && success) {
        form.style.display = 'none';
        success.style.display = 'block';
      }
    }

    // Initialize collection page handlers
    function initializeCollectionHandlers() {
      cleanupLegacyPdpBis();

      // Handle clicks on notify buttons
      document.addEventListener('click', function (e) {
        if (e.target.closest('.klaviyo-collection-bis-trigger')) {
          e.preventDefault();

          const button = e.target.closest('.klaviyo-collection-bis-trigger');
          const productId = button.getAttribute('data-product-id') || button.getAttribute('data-variant');
          const variantId = button.getAttribute('data-variant') || productId;
          const productName =
            button.getAttribute('data-product-name') || button.getAttribute('data-product-title') || 'Product';

          // console.log('Debug - Product Name:', productName);
          // console.log('Debug - data-product-name:', button.getAttribute('data-product-name'));
          // console.log('Debug - data-product-title:', button.getAttribute('data-product-title'));

          if (productId) {
            window.showKlaviyoBisModal(productId, productName, variantId);
          }
        }
      });
    }

    function cleanupLegacyPdpBis() {
      const isPdpContext =
        document.body?.classList.contains('product') ||
        document.querySelector('#v2pdp-json') ||
        document.querySelector('.ombraz-v2pdp');

      if (!isPdpContext) return;

      const removeLegacyNodes = () => {
        document.querySelectorAll('a.btn.klaviyo-bis-trigger, iframe#klaviyo-bis-iframe').forEach((node) => {
          node.remove();
        });
      };

      removeLegacyNodes();

      const observer = new MutationObserver(removeLegacyNodes);
      observer.observe(document.body, { childList: true, subtree: true });
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeCollectionHandlers);
    } else {
      initializeCollectionHandlers();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["optional-addons"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const addonCheckboxes = document.querySelectorAll('.addon__checkbox');
    const oldAddonCheckboxes = document.querySelectorAll('.ombraz-v2pdp__toggle-input');
    const addOnDialogBtns = document.querySelectorAll('.addon__learn-more');
    const oldAddonDialogBtns = document.querySelectorAll('.ombraz-v2pdp__dialog-opener');

    if (
      !addonCheckboxes.length ||
      !oldAddonCheckboxes.length ||
      !addOnDialogBtns.length ||
      !oldAddonDialogBtns.length
    ) {
      return;
    }

    // Initial sync - check if old checkboxes are checked
    oldAddonCheckboxes.forEach((oldCheckbox) => {
      if (oldCheckbox.checked) {
        const newCheckbox = document.querySelector(`.addon__checkbox[value="${oldCheckbox.value}"]`);
        if (newCheckbox && !newCheckbox.checked) {
          newCheckbox.checked = true;
        }
      }
    });

    // Handle changes on new checkboxes
    addonCheckboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', function () {
        const checkboxId = this.value;
        const oldAddonCheckbox = document.querySelector(`input[type="checkbox"][value="${checkboxId}"]`);

        if (this.checked) {
          oldAddonCheckbox.checked = true;
          oldAddonCheckbox.dispatchEvent(new Event('change'));
        } else {
          oldAddonCheckbox.checked = false;
          oldAddonCheckbox.dispatchEvent(new Event('change'));
        }
      });
    });

    // Handle changes on old checkboxes
    oldAddonCheckboxes.forEach((oldCheckbox) => {
      oldCheckbox.addEventListener('change', function () {
        const newCheckbox = document.querySelector(`.addon__checkbox[value="${this.value}"]`);
        if (newCheckbox) {
          newCheckbox.checked = this.checked;
        }
      });
    });

    addOnDialogBtns.forEach((btn) => {
      btn.addEventListener('click', function (event) {
        event.preventDefault();

        // if current btn text is same as the old addon btn text then click the old addon btn
        const btnAddonId = this.dataset.addonId;
        const oldAddonBtn = Array.from(oldAddonDialogBtns).find((oldBtn) => {
          return oldBtn.dataset.addonId === btnAddonId;
        });

        const isSmallDevice = window.matchMedia('(max-width: 1199px)').matches;

        if (oldAddonBtn) {
          oldAddonBtn.dispatchEvent(new Event('click'));

          if (isSmallDevice) {
            document
              .querySelector('.ombraz-v2pdp__addon-toggle-list')
              ?.style.setProperty('display', 'grid', 'important');
          }
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
